export default __webpack_public_path__ + "assets/491101ae48c9f25aa1cff48def3fae5a.png";